import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './msalConfig.js';

// Wraps routed content. If the user isn't signed in and MSAL is idle, we
// call loginRedirect() immediately — matches the "incognito → Microsoft login"
// behavior required by the HIPAA go-live checklist.
export default function AuthGate({ children }) {
  const { instance, inProgress } = useMsal();
  const isAuthed = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthed && inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest).catch(() => { /* MSAL logs its own errors */ });
    }
  }, [isAuthed, inProgress, instance]);

  if (!isAuthed) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100%', color: 'var(--lumen-text-secondary)',
        fontFamily: 'var(--font-sans)', fontSize: 13
      }}>
        Redirecting to Microsoft sign-in…
      </div>
    );
  }
  return children;
}
